import { baseThemeValues } from 'constants/common';

const baseButtonProps = {
  boxShadow: 'palette.transparent',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 500,
  outlineColor: 'palette.transparent',
  outlineWidth: '0px',
};

const baseIconProps = {
  ...baseButtonProps,
  borderColor: 'palette.transparent',
  borderRadius: '30px',
  borderWidth: '0px',
};

export const integrationBuilderOperationForm = {
  actionButton: {
    base: {
      ...baseIconProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.30',
    },
    baseProps: baseIconProps,
    disabled: {
      ...baseIconProps,
      bg: 'palette.transparent',
      text: 'palette.neutral.30',
    },
    focus: {
      ...baseIconProps,
      bg: 'palette.transparent',
      text: 'palette.primary.99',
    },
    hover: {
      ...baseIconProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.95',
    },
    pressed: {
      ...baseIconProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.95',
    },
  },
  variablesBlock: {
    borderColor: 'palette.tertiary.5',
    borderRadius: '8px',
    borderWidth: '1px',
    item: {
      bg: 'palette.surface.3',
      borderRadius: '4px',
    },
    label: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '12px',
      fontWeight: 500,
      text: 'palette.primary.60',
    },
  },
};
